export enum BackgroundTaskKind {
    ProductsImport = 'ProductsImport',
    ClientsImport = 'ClientsImport',
    PackageOfDocumentsGeneration = 'PackageOfDocumentsGeneration'
}
